import * as yup from 'yup';

export const createAmsPartDialogSchema = yup.object().shape({
  type: yup.string().required().label('Type'),
  brewerId: yup
    .string()
    .transform((value) => (value === '' ? null : value))
    .required()
    .label('Brewer'),
  skuBrewer: yup.string().nullable().default(null).label('SKU Brewer'),
  skuAvani: yup.string().nullable().default(null).label('SKU Avani'),
  description: yup.string().nullable().default(null).label('Description'),
  manufacturer: yup.string().nullable().default(null).label('Manufacturer'),
  mainCategory: yup.string().nullable().default(null).label('Category'),
  subCategory: yup.string().nullable().default(null).label('Sub Category'),
  package: yup.number().transform(transformEmptyStringToNull).nullable().default(null).label('Package Size'),
  priceBuyUnit: yup.number().transform(transformEmptyStringToNull).nullable().default(null).label('Price Buy Unit'),
  priceBuyPack: yup.number().transform(transformEmptyStringToNull).nullable().default(null).label('Price Buy Pack'),
  priceSellUnit: yup.number().transform(transformEmptyStringToNull).nullable().default(null).label('Price Sell Unit'),
  stockThreshold: yup.number().transform(transformEmptyStringToNull).nullable().default(null).label('Par Level')
});
export const updateAmsPartDialogSchema = yup.object().shape({
  amsPartId: yup.string().required().label('Ams Part ID'),
  type: yup.string().required().label('Type'),
  brewerId: yup
    .string()
    .transform((value) => (value === '' ? null : value))
    .required()
    .label('Brewer'),
  skuBrewer: yup.string().nullable().default(null).label('SKU Brewer'),
  skuAvani: yup.string().nullable().default(null).label('SKU Avani'),
  description: yup.string().nullable().default(null).label('Description'),
  manufacturer: yup.string().nullable().default(null).label('Manufacturer'),
  mainCategory: yup.string().nullable().default(null).label('Category'),
  subCategory: yup.string().nullable().default(null).label('Sub Category'),
  package: yup.number().transform(transformEmptyStringToNull).nullable().default(null).label('Package Size'),
  priceBuyUnit: yup.number().transform(transformEmptyStringToNull).nullable().default(null).label('Price Buy Unit'),
  priceBuyPack: yup.number().transform(transformEmptyStringToNull).nullable().default(null).label('Price Buy Pack'),
  priceSellUnit: yup.number().transform(transformEmptyStringToNull).nullable().default(null).label('Price Sell Unit'),
  stockThreshold: yup.number().transform(transformEmptyStringToNull).nullable().default(null).label('Par Level')
});

function transformEmptyStringToNull(value: any) {
  return Number.isNaN(value) ? null : value;
}
